"use client";
import { useState } from 'react';
import { FileText } from 'lucide-react';
import DossierModal from '../ui/DossierModal';
import { trackContactClick } from '@/components/PixelTracker';

export default function FAQSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);



  return (
    <section id="faq" className="py-8 md:py-8 bg-white">
      <div className="max-w-4xl mx-auto sm:px-6 lg:px-8">
        

        {/* Contact section */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* WhatsApp contact */}
          <div className="bg-gray-50 p-8 rounded-xl text-center">
            <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
              <svg className="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
            </div>
            <h3 className="text-xl font-heading uppercase tracking-heading text-foreground mb-4">
              ¿Más preguntas?
            </h3>
            <p className="text-gray-700 mb-6">
              Escríbeme directamente y hablamos
            </p>
            <a
              href="https://wa.me/34651062898?text=Hola%20Toño,%20tengo%20una%20pregunta%20sobre%20la%20certificación"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackContactClick()}
              className="inline-block px-6 py-3 bg-green-600 text-background font-heading uppercase tracking-heading font-medium rounded-full shadow-lg hover:bg-green-700 transition-all duration-300"
              aria-label="Abrir WhatsApp para contactar a Toño Galán (se abre en nueva pestaña)"
            >
              Abrir WhatsApp
            </a>
          </div>

          {/* Dossier download */}
          <div className="bg-gray-50 p-8 rounded-xl text-center">
            <div className="w-16 h-16 bg-[#97d700]/10 rounded-2xl flex items-center justify-center mb-4 mx-auto">
              <FileText className="w-8 h-8 text-[#97d700]" />
            </div>
            <h3 className="text-xl font-heading uppercase tracking-heading text-foreground mb-4">
              Información completa
            </h3>
            <p className="text-gray-700 mb-6">
              Descarga el dossier con el programa detallado
            </p>
            <button
              onClick={() => setIsModalOpen(true)}
              className="inline-block px-6 py-3 bg-accent text-background font-heading uppercase tracking-heading font-medium rounded-full shadow-lg hover:bg-opacity-90 transition-all duration-300"
              aria-label="Descargar dossier informativo completo"
            >
              Descargar dossier
            </button>
          </div>
        </div>

        
      </div>

      {/* Dossier Modal */}
      <DossierModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
